import { render } from "./ReportBase.vue?vue&type=template&id=7ec2e067&scoped=true"
import script from "./ReportBase.vue?vue&type=script&lang=js"
export * from "./ReportBase.vue?vue&type=script&lang=js"

import "./ReportBase.vue?vue&type=style&index=0&id=7ec2e067&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ec2e067"]])

export default __exports__